import { IdbRepo } from './idbRepo'
import { LocalRepo } from './localRepo'
import type { Repo } from './repo'

let instance: Repo | null = null
let pending: Promise<Repo> | null = null

/**
 * Prefer IndexedDB; fall back to localStorage if it is missing, blocked or hangs.
 * Resolved once and cached so every screen shares one connection.
 */
export function getRepo(): Promise<Repo> {
  if (instance) return Promise.resolve(instance)
  if (pending) return pending

  pending = (async () => {
    if (typeof indexedDB !== 'undefined') {
      try {
        const idb = new IdbRepo()
        await idb.init()
        instance = idb
        return idb
      } catch (err) {
        console.warn('[storage] IndexedDB unavailable, falling back to localStorage', err)
      }
    }
    const local = new LocalRepo()
    await local.init()
    instance = local
    return local
  })()

  return pending
}

export type { Repo } from './repo'
export { META_CURRENT_GAME, META_CURRENT_SEASON, META_LAST_EXPORT } from './repo'
